define('presentation/receptionist/facades/receptionistMessageFacade',['common/converters/phoneNumberFormatter',
        'common/converters/userFormatter',
        'common/promises/promiseFactory',
        'constants/receptionistMessageConstants',
        'externalDependencies/clientWebSocket',
        'presentation/common/callDetails/common/callDetailsBuilder',
        'presentation/common/callDetails/presentationObjects/callDetailsPresentationObject',
        'presentation/common/callDetails/presentationObjects/callDetailsReceptionistMessagePresentationObject',
    ],
    function () {
        const PhoneNumberFormatterConstructor = require('common/converters/phoneNumberFormatter');
        const _phoneNumberFormatter = new PhoneNumberFormatterConstructor();

        const UserFormatterConstructor = require('common/converters/userFormatter');
        const _userFormatter = new UserFormatterConstructor();

        const _clientWebSocket = require('externalDependencies/clientWebSocket');
        const _callDetailsSocket = _clientWebSocket.forApplication('callDetails');
        const _receptionistMessageSocket = _clientWebSocket.forApplication('receptionistMessage');

        const CallDetailsBuilderConstructor = require('presentation/common/callDetails/common/callDetailsBuilder');
        const _callDetailsBuilder = new CallDetailsBuilderConstructor();

        const CallDetailsPresentationObject = require('presentation/common/callDetails/presentationObjects/callDetailsPresentationObject');
        const CallDetailsReceptionistMessagePresentationObject = require('presentation/common/callDetails/presentationObjects/callDetailsReceptionistMessagePresentationObject');

        const receptionistMessageConstants = require('constants/receptionistMessageConstants');

        let _promiseFactory = null;

        const init = (promiseFactory) => {
            _promiseFactory = promiseFactory;
            _callDetailsBuilder.init();
        };

        const _formatFormResponsesForDisplay = (formResponses) => {
            if (formResponses === null || formResponses === undefined) {
                return [];
            }

            return formResponses.map((response) => {
                const { formKey, formValue } = response;
                return {
                    key: formKey,
                    value: formValue.trim() ? formValue : "-"
                };
            });
        };

        const _getReceptionistMessageById = (messageId) => {
            return _promiseFactory.deferIndefinitely((promise) => {
                _receptionistMessageSocket.send('getReceptionistMessageWithCallHistory', { messageId }, (receptionistMessageResult) => {
                    if (receptionistMessageResult === null) {
                        promise.resolve(null);
                        return;
                    }

                    if (receptionistMessageResult.callHistoryId) {
                        let callDetails = new CallDetailsPresentationObject();
                        callDetails = _callDetailsBuilder.formatCallDetailsForDisplay(receptionistMessageResult.callHistoryId, receptionistMessageResult.callDetails);
                        callDetails.receptionistMessage.formResponses = _formatFormResponsesForDisplay(receptionistMessageResult.formResponses);

                        const mapRequest = {
                            callerLocation: callDetails.callerLocation,
                            calleeLocation: callDetails.calleeLocation,
                            mapHeight: 200,
                            mapWidth: 1018
                        };
                        _callDetailsSocket.send('getCallDetailsMapUrl', mapRequest, (mapResult) => {
                            if (mapResult) {
                                callDetails.mapUrl = mapResult;
                            }

                            receptionistMessageResult.callDetails = callDetails;
                            promise.resolve(receptionistMessageResult);
                        });
                    } else {
                        let callDetailsReceptionistMessage = new CallDetailsReceptionistMessagePresentationObject();
                        callDetailsReceptionistMessage.receptionistMessageId = receptionistMessageResult.receptionistMessageId;
                        callDetailsReceptionistMessage.scriptName = receptionistMessageResult.liveReceptionistScriptDisplayName;
                        callDetailsReceptionistMessage.interactionType = receptionistMessageResult.interactionType;
                        callDetailsReceptionistMessage.employeeName = _userFormatter.formatFirstNameLastInitial(receptionistMessageResult.employeeName);
                        callDetailsReceptionistMessage.formName = receptionistMessageResult.formName;
                        callDetailsReceptionistMessage.formResponses = _formatFormResponsesForDisplay(receptionistMessageResult.formResponses);
                        callDetailsReceptionistMessage.isJunk = receptionistMessageResult.isJunk;
                        callDetailsReceptionistMessage.junkStatus = receptionistMessageResult.junkStatus;
                        callDetailsReceptionistMessage.participantName = receptionistMessageResult.participantName;
                        callDetailsReceptionistMessage.participantEmailAddress = receptionistMessageResult.participantEmailAddress;
                        callDetailsReceptionistMessage.domain = receptionistMessageResult.domain;
                        callDetailsReceptionistMessage.webChatTranscript = receptionistMessageResult.webChatTranscript.map((transcriptMessage) => {
                            if (transcriptMessage.isAgent) {
                                transcriptMessage.sender = _userFormatter.formatFirstNameLastInitial(transcriptMessage.sender);
                            }
                            return transcriptMessage;
                        });
                        callDetailsReceptionistMessage.subscriberIds(receptionistMessageResult.subscriberIds);
                        let smsRecipients = receptionistMessageResult.smsRecipients || [];
                        let recipients = receptionistMessageResult.recipients || [];
                        let formattedSmsRecipients = smsRecipients.map((smsRecipient) => {
                            return _phoneNumberFormatter.toInternationalWithParens(smsRecipient);
                        });
                        callDetailsReceptionistMessage.recipients = recipients.concat(formattedSmsRecipients).sort();

                        let callDetails = new CallDetailsPresentationObject();
                        callDetails.receptionistMessage = callDetailsReceptionistMessage;

                        receptionistMessageResult.callDetails = callDetails;
                        promise.resolve(receptionistMessageResult);
                    }
                });
            });
        };

        const setReceptionistMessageStatus = (receptionistMessageId, newStatus) => {
            return _promiseFactory.deferIndefinitely((promise) => {
                let status;
                switch (newStatus) {
                    case receptionistMessageConstants.status.new.name:
                        status = receptionistMessageConstants.status.new.id;
                        break;
                    case receptionistMessageConstants.status.reviewed.name:
                        status = receptionistMessageConstants.status.reviewed.id;
                        break;
                    default:
                        throw new Error('Unknown status: ' + newStatus);
                }

                const request = {
                    receptionistMessageId: receptionistMessageId,
                    status: status,
                };

                _receptionistMessageSocket.send("setMessageStatus", request, (result) => {
                    promise.resolve(result);
                });
            });
        };

        return function () {
            let self = this;

            self.init = init;
            self.getReceptionistMessageById = _getReceptionistMessageById;
            self.setReceptionistMessageStatus = setReceptionistMessageStatus;
        };
    }
);
